import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../../services/api';
import API_CONFIG from '../../../config/api.config';

const ModalItensCotacao = ({ open, onClose, cotacaoId }) => {
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const isMobile = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    if (open && cotacaoId) {
      setLoading(true);
      setErro('');
      setItens([]);
      api.get(API_CONFIG.ENDPOINTS.COTACOES.ITENS_COTACAO(cotacaoId), { params: { page: 1 } })
        .then(response => {
          if (response.data && response.data.status && response.data.itens) {
            setItens(response.data.itens.map(item => ({
              IT_NOME: item.item?.IT_NOME,
              IT_DESCRICAO: item.item?.IT_DESCRICAO,
              IT_QUANTIDADE: item.item?.IT_QUANTIDADE,
              item_compra: { ITC_VALOR_ORIGINAL: item.IC_VALOR }
            })));
          } else {
            setErro('Itens não encontrados.');
          }
        })
        .catch(() => setErro('Erro ao buscar itens da cotação.'))
        .finally(() => setLoading(false));
    }
  }, [open, cotacaoId]);

  const formatarValor = (valor) => {
    if (!valor) return 'R$ 0,00';
    return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const calcularValorTotal = () => {
    if (!itens || itens.length === 0) return 0;
    return itens.reduce((total, item) => {
      const valor = Number(item.item_compra?.ITC_VALOR_ORIGINAL || 0);
      const quantidade = Number(item.IT_QUANTIDADE || 0);
      return total + (valor * quantidade);
    }, 0);
  };

  const valorTotal = calcularValorTotal();

  if (loading) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Itens da Cotação</DialogTitle>
        <DialogContent>
          <Typography>Carregando itens...</Typography>
        </DialogContent>
      </Dialog>
    );
  }

  if (erro) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Itens da Cotação</DialogTitle>
        <DialogContent>
          <Typography color="error">{erro}</Typography>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Itens da Cotação {cotacaoId}</Typography>
          <Button onClick={onClose} color="inherit">
            <CloseIcon />
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Produto</TableCell>
                <TableCell>Descrição</TableCell>
                <TableCell align="center">Quantidade</TableCell>
                <TableCell align="right">Valor Unitário</TableCell>
                <TableCell align="right">Valor Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {itens.length > 0 ? itens.map((item, idx) => {
                const valorUnitario = Number(item.item_compra?.ITC_VALOR_ORIGINAL || 0);
                const quantidade = Number(item.IT_QUANTIDADE || 0);
                const valorTotalItem = valorUnitario * quantidade;
                return (
                  <TableRow key={idx}>
                    <TableCell>{item.IT_NOME}</TableCell>
                    <TableCell>{item.IT_DESCRICAO || '---'}</TableCell>
                    <TableCell align="center">{quantidade}</TableCell>
                    <TableCell align="right">{formatarValor(valorUnitario)}</TableCell>
                    <TableCell align="right">{formatarValor(valorTotalItem)}</TableCell>
                  </TableRow>
                );
              }) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">Nenhum item encontrado.</TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell colSpan={4} align="right">
                  <strong>Total da Cotação:</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>{formatarValor(valorTotal)}</strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalItensCotacao; 